var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D4E6D",
    d: "m13.964 13.137-3.896-3.895A4.46 4.46 0 0 0 11 6.5c0-1.203-.47-2.331-1.319-3.182A4.467 4.467 0 0 0 6.5 2c-1.202 0-2.333.47-3.182 1.318A4.464 4.464 0 0 0 2 6.5c0 1.201.47 2.332 1.318 3.181A4.464 4.464 0 0 0 6.5 11a4.463 4.463 0 0 0 2.74-.93l3.896 3.894a.121.121 0 0 0 .087.036.122.122 0 0 0 .087-.036l.654-.652a.123.123 0 0 0 0-.175ZM8.876 8.877A3.342 3.342 0 0 1 6.5 9.86c-.897 0-1.74-.35-2.376-.984A3.342 3.342 0 0 1 3.14 6.5c0-.897.35-1.742.984-2.376A3.342 3.342 0 0 1 6.5 3.14c.897 0 1.741.348 2.376.984.634.636.984 1.479.984 2.376a3.34 3.34 0 0 1-.984 2.376Z"
  })));
};
export default SvgSearch;